export default {
  ADD_NEWS_ITEM(state, newsItem) {
    state.newsItems.collection.unshift(newsItem);
  },

  DELETE_NEWS_ITEM(state, id) {
    const index = state.newsItems.collection.findIndex((newsItem) => newsItem.id === id);
    if (index >= 0) {
      state.newsItems.collection.splice(index, 1);
    }
  },

  SET_NEWS_ITEM(state, updatedNewsItem) {
    const index = state.newsItems.collection.findIndex((item) => item.id === updatedNewsItem.id);
    if (index >= 0) {
      state.newsItems.collection.splice(index, 1, updatedNewsItem);
    }
  },

  SET_NEWS_ITEMS(state, newsItems) {
    state.newsItems = newsItems;
  },

  SET_EDITING_NEWS_ITEM(state, editingNewsItem) {
    state.editingNewsItem = editingNewsItem;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGINATOR(state, { page, size, total }) {
    state.paginator.page = page;
    state.paginator.size = size;
    state.paginator.total = total;
  },

  SET_PAGINATOR_PAGE(state, value) {
    state.paginator.page = value;
  },

  SET_PAGINATOR_LOADING_PAGE(state, value) {
    state.paginator.loadingPage = value;
  },

  SET_SORT(state, sort) {
    state.sort = sort;
  },
};
